/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Video_Export_Export_Preset_LoadedInputs */

const en_video_export_export_preset_loaded = /** @type {(inputs: Video_Export_Export_Preset_LoadedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Video export preset "${i?.name}" loaded`)
};

const fr_video_export_export_preset_loaded = /** @type {(inputs: Video_Export_Export_Preset_LoadedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Prereglage d'exportation video "${i?.name}" charge`)
};

const de_video_export_export_preset_loaded = /** @type {(inputs: Video_Export_Export_Preset_LoadedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Videoexport-Voreinstellung "${i?.name}" geladen`)
};

const it_video_export_export_preset_loaded = /** @type {(inputs: Video_Export_Export_Preset_LoadedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Preimpostazione di esportazione video "${i?.name}" caricata`)
};

const ru_video_export_export_preset_loaded = /** @type {(inputs: Video_Export_Export_Preset_LoadedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Загружена предустановка экспорта видео "${i?.name}".`)
};

const es_video_export_export_preset_loaded = /** @type {(inputs: Video_Export_Export_Preset_LoadedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Se cargó el ajuste preestablecido de exportación de vídeo "${i?.name}"`)
};

const zh_cn2_video_export_export_preset_loaded = /** @type {(inputs: Video_Export_Export_Preset_LoadedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`视频导出预设“${i?.name}”已加载`)
};

const ja_video_export_export_preset_loaded = /** @type {(inputs: Video_Export_Export_Preset_LoadedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ビデオエクスポートプリセット「${i?.name}」が読み込まれました`)
};

const hi_video_export_export_preset_loaded = /** @type {(inputs: Video_Export_Export_Preset_LoadedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`वीडियो निर्यात प्रीसेट "${i?.name}" लोड हो गया`)
};

const pt_pt2_video_export_export_preset_loaded = /** @type {(inputs: Video_Export_Export_Preset_LoadedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Predefinição de exportação de vídeo "${i?.name}" carregada`)
};

/**
* | output |
* | --- |
* | "Video export preset \"{name}\" loaded" |
*
* @param {Video_Export_Export_Preset_LoadedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_export_preset_loaded = /** @type {((inputs: Video_Export_Export_Preset_LoadedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Export_Preset_LoadedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_video_export_export_preset_loaded(inputs)
	if (locale === "de") return de_video_export_export_preset_loaded(inputs)
	if (locale === "it") return it_video_export_export_preset_loaded(inputs)
	if (locale === "ru") return ru_video_export_export_preset_loaded(inputs)
	if (locale === "es") return es_video_export_export_preset_loaded(inputs)
	if (locale === "zh-CN") return zh_cn2_video_export_export_preset_loaded(inputs)
	if (locale === "ja") return ja_video_export_export_preset_loaded(inputs)
	if (locale === "hi") return hi_video_export_export_preset_loaded(inputs)
	if (locale === "pt-PT") return pt_pt2_video_export_export_preset_loaded(inputs)
	return en_video_export_export_preset_loaded(inputs)
});